export default [
  { id: '1', name: 'Movimientos de Caja', altName: 'Movimientos de Caja' },
  { id: '2', name: 'Ingresos / Egresos', altName: 'Ingresos / Egresos' },
  { id: '3', name: 'Movimientos de Inicializacion', altName: 'Movimientos de Inicializacion' },
]